export interface ILog {
  date: string;
  title: any;
  payload: any;
  type: LogType;
}

export interface ITransactionLog {
  id: number;
  typ: LogType;
  msg: string;
  dt: number;
}

export enum LogType {
  Info,
  Warn,
  Error,
  Internal,
}